var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdult(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1032_9075",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#4F4F4F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1032_9075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04951 11.847C6.04951 12.3573 6.04951 12.863 6.04951 13.3733C6.04951 13.9839 6.46798 14.394 7.08205 14.3985C7.61424 14.3985 8.14188 14.3985 8.67408 14.3985C9.26995 14.3985 9.68842 13.9793 9.68842 13.3825C9.68842 12.3482 9.69297 11.3184 9.68842 10.2841C9.68842 10.1565 9.71571 10.0882 9.84308 10.029C10.3434 9.79659 10.5936 9.38652 10.5982 8.8352C10.6027 8.0834 10.6027 7.3316 10.5982 6.5798C10.5936 5.60929 9.82033 4.83471 8.85147 4.83015C8.19192 4.83015 7.53237 4.82559 6.87281 4.83015C5.9176 4.83471 5.14433 5.61385 5.14433 6.57068C5.13978 7.32248 5.13978 8.07428 5.14433 8.82608C5.14888 9.38652 5.4036 9.79659 5.91305 10.0335C6.01767 10.0836 6.05406 10.1383 6.05406 10.2522C6.04496 10.7808 6.04951 11.3139 6.04951 11.847Z",
    fill: "url(#paint0_linear_1032_9075)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.87896 4.41554C8.64768 4.41554 9.27539 3.78676 9.27539 3.01218C9.27539 2.2376 8.62493 1.59059 7.85621 1.5997C7.09204 1.60882 6.45978 2.25127 6.45978 3.01218C6.45978 3.79132 7.09659 4.4201 7.87896 4.41554Z",
    fill: "url(#paint1_linear_1032_9075)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1032_9075",
    x1: 7.87124,
    y1: 4.82812,
    x2: 7.87124,
    y2: 14.3985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1032_9075",
    x1: 7.86759,
    y1: 1.59961,
    x2: 7.86759,
    y2: 4.41556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FE8888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0D98C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdult);
export default __webpack_public_path__ + "static/media/adult.5277d070a0d60d469bbf1ec492277d66.svg";
export { ForwardRef as ReactComponent };